
















































import { Watch, Vue, Component } from '@samclick-commons';
import {
  _isEmpty, _reverse, _sortBy, _get,
} from '@/plugins/lodash';

class Pagination {
    pageIndex: number = 1

    pageSize: number = 10
}

enum SamclickDatatableType {
    REMOTE = 'remote',
    LOCAL = 'local',
}

@Component({
/**
 * Component properties
 * */
  props: {
    data: {
      type: Array,
      required: true,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    dataType: {
      type: String,
      default: 'local',
      validator(value) {
        // The value must match one of these strings
        return ['local', 'remote'].indexOf(value) !== -1;
      },
    },
  },
})
class SamclickDatatable extends Vue {
    pagination = new Pagination()

    sortInfo: object = {}

    cachedData: Array<object> = [];

    // Keep cachedData in sync whenever the bound data changes.
    @Watch('data', { deep: true, immediate: true })
    onDataChange() {
      this.updateCachedData();
    }

    emitEventHandler(event: string, ...args: any) {
      this.$emit(event, ...args);
    }

    handleSizeChange(newPageSize: number) {
      this.pagination.pageSize = newPageSize;
      this.emitEventHandler('pagination-change', this.pagination);
    }

    handleCurrentChange(newPageIndex: number) {
      this.pagination.pageIndex = newPageIndex;
      this.emitEventHandler('pagination-change', this.pagination);
    }

    computedData() {
      const page = this.pagination.pageIndex;
      const perPage = this.pagination.pageSize;
      const from = (page * perPage) - perPage;
      const to = (page * perPage);
      const clone = this.sort();
      return clone.slice(from, to);
    }

    sort() {
      let clone = [...this.$props.data];
      const sort = this.sortInfo;

      if (_isEmpty(sort)) {
        return clone;
      }
      if (!_isEmpty(sort.column) && sort.column.sortMethod) {
        clone.sort((a, b) => sort.column.sortMethod(a, b));

        if (sort.order === 'descending') {
          clone.reverse();
        }
      } else if (sort.order === 'ascending') {
        clone = this.sortAsc(clone, sort);
      } else if (sort.order === 'descending') {
        clone = _reverse(this.sortAsc(clone, sort));
      }

      return clone;
    }

    sortAsc(list: Array<object>, sort: object) {
      return _sortBy(list, [function (o) {
        let props = _get(o, sort.prop);
        if (typeof props === 'string') {
          props = props.toLowerCase();
        }

        return props;
      }]);
    }

    resetPagination() {
      this.pagination = new Pagination();
    }

    getPaginationInfo() {
      return this.pagination;
    }

    changeHead() {
      return { backgroundColor: '#F5F7FA', border: '1px solid #EBEEF5' };
    }

    sortChanged(args: object) {
      this.sortInfo = args.order ? args : {};
      this.$forceUpdate();
    }

    get defaultAttrs() {
      return {
        stripe: true,
        style: 'width: 100%',
      };
    }

    get overrideAttrs() {
      return Object.assign(this.defaultAttrs, this.$attrs);
    }

    beforeUpdate() {
      this.updateCachedData();
    }

    mounted() {
      if (this.$attrs['default-sort']) {
        this.sortInfo = this.$attrs['default-sort'];
      }
    }

    updateCachedData() {
      if (this.$props.dataType === 'local' && this.$props.showPagination) {
        this.cachedData = this.computedData();
      } else if (this.$props.dataType === 'local') {
        this.cachedData = this.sort();
      } else {
        this.cachedData = this.$props.data;
      }
    }
}

export { SamclickDatatableType };
export default SamclickDatatable;
